import { render, staticRenderFns } from "./PartnerCategory.vue?vue&type=template&id=035b5434&scoped=true&"
import script from "./PartnerCategory.vue?vue&type=script&lang=js&"
export * from "./PartnerCategory.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCategory.vue?vue&type=style&index=0&id=035b5434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b5434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035b5434')) {
      api.createRecord('035b5434', component.options)
    } else {
      api.reload('035b5434', component.options)
    }
    module.hot.accept("./PartnerCategory.vue?vue&type=template&id=035b5434&scoped=true&", function () {
      api.rerender('035b5434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integrations/PartnerCategory.vue"
export default component.exports